import { Scene, Choice, Dialog } from "../models";
import { scenes } from "../scenes";

let breakingInDialog = [
  new Dialog(
    "SONNY YANG: Alright Glenn, I’ll need you to use your ape - like strength to bend an opening in these iron bars.",
    require("@/images/sonny.png"),
    require("@/audio/Pandemic-34-Sonny-MP3.mp3")
  ),
  new Dialog(
    "GLENN: Sure thing boss.",
    require("@/images/glenn.png"),
    require("@/audio/Pandemic-34-Glenn-MP3.mp3")
  ),
  new Dialog(
    "COP: Hold it right there scum! Under the new social distancing laws, gatherings of two or more people in public are prohibited, unless the gathering in question is of an adult guardian and a child dependant.I’m afraid I’m going to have to shoot you Sonny Yang.",
    require("@/images/Cop.png"),
    require("@/audio/Pandemic-34-Cop-MP3.mp3")
  ),
  new Dialog(
    "[Police Officer Moyle shoots you on sight!]",
    require("@/images/Gun.png"),
    require("@/audio/loseitem.mp3")
  ),
];

let diaperBreakingInDialog = [
  new Dialog(
    "SONNY YANG: Alright Glenn, first I’ll need you to put on these ADULT DIAPERS",
    require("@/images/sonny.png"),
    require("@/audio/Pandemic-35-Sonny1-MP3.mp3")
  ),
  new Dialog(
    " GLENN: Okay, I guess.",
    require("@/images/Glenn_Baby.png"),
    require("@/audio/Pandemic-35-Glenn1-MP3.mp3")
  ),
  new Dialog(
    "SONNY YANG:  Now I need you to use your ape - like strength to bend an opening through these iron bars.",
    require("@/images/sonny.png"),
    require("@/audio/Pandemic-34-Sonny-MP3.mp3")
  ),
  new Dialog(
    "COP: Hold it right there scum! Under the new social distancing laws, gatherings of two or more people in public are prohibited, unless the gathering in question is of an adult guardian and a child dependant.I’m afraid I’m going to have to shoot you Sonny Yang.",
    require("@/images/Cop.png"),
    require("@/audio/Pandemic-34-Cop-MP3.mp3")
  ),
  new Dialog(
    "SONNY YANG: Officer, as you can clearly see, I am out with none other than my infant son.",
    require("@/images/sonny.png"),
    require("@/audio/Pandemic-35-Sonny2-MP3.mp3")
  ),
  new Dialog(
    "BABY GLENN: I love Daddy",
    require("@/images/Glenn_Baby.png"),
    require("@/audio/Pandemic-35-Glenn2-MP3.mp3")
  ),
  new Dialog(
    "COP: How precious! Sorry to bother you Sonny Yang, carry on as you were.",
    require("@/images/Cop.png"),
    require("@/audio/Pandemic-35-Cop-MP3.mp3")
  ),
  new Dialog(
    "[GLENN CREATES AN OPENING IN THE FENCE!]",
    require("@/images/Glenn_Baby.png"),
    require("@/audio/Found_Jingle.mp3")
  ),
  new Dialog(
    "BABY GLENN: Can I go home now?",
    require("@/images/Glenn_Baby.png"),
    require("@/audio/Pandemic-35-Glenn3-MP3.mp3")
  ),
  new Dialog(
    "SONNY YANG: Certainly old friend.You are dismissed.",
    require("@/images/sonny.png"),
    require("@/audio/Pandemic-35-Sonny3-MP3.mp3")
  ),
];

export class DarethsFence extends Scene {
  title = "Dareth's Fence";
  async init() {
    this.image = require("@/images/Dareths_Fence.png");

    if (!this.state.storylines.fenceOpened && !this.state.inventory.glenn.has) {
      this.description =
        "SONNY YANG: It seems Dareth’s overcompensatory house is surrounded by a TALL IRON FENCE. ";
      this.state.storylines.findGlenn = true;
      this.image = require("@/images/Dareths_Fence.png");
      this.audio = require("@/audio/Pandemic-32-Sonny-MP3.mp3");
    } else {
      this.audio = "";
      this.description = "";
    }
  }

  get options(): any[] {
    let choices = [
      new Choice("Climb through fence", async () => {
        if (this.state.storylines.fenceOpened) {
          await this.navigate(scenes.DarethsYard());
        } else {
          if (this.state.inventory.glenn.has) {
            if (this.state.inventory.diapers.has) {
              await this.dialogRunner(diaperBreakingInDialog)
              this.state.inventory.diapers.has = false;
              this.state.inventory.glenn.has = false;
              this.state.storylines.fenceOpened = true;
              await this.navigate(scenes.DarethsYard());
            } else {
              await this.dialogRunner(breakingInDialog)
              this.state.storylines.buyDiapers = true;
              await this.navigate(scenes.EmergencyRoom());
            }
          } else {
            this.description =
              "SONNY YANG: If I were a STRONGER MAN, I might be able to bend an opening through the bars, but alas…";
            this.audio = require("@/audio/Pandemic-33-Sonny-MP3.mp3");
          }
        }
      }),
      new Choice("Leave", async () => await this.navigate(scenes.DarethsHouseExterior())),
    ];
    return choices;
  }
}
export default new DarethsFence();
